<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} Online Test</h1>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="form-group col-12">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Name</label>
            <input type="text" class="form-control col-lg-8" id="form-title" placeholder="Name" v-model="name">
          </div>
        </div>
        <div class="form-group col-12">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex">Description</label>
            <div class="col-lg-8 p-0 m-0 d-flex">
              <textarea class="form-control" id="description" v-html="description"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3" v-for="(data,index) in arr_question" :key="'question_'+index">
      <div class="card-body">
        <div class="form-group col-12">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Pertanyaan</label>
            <div class="col-lg-8 p-0 m-0 d-flex">
              <textarea class="form-control" :index_attr="index" v-html="data.question" v-model="data.question"></textarea>
            </div>
            <!-- <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center mt-3">Score</label>
            <div class="col-lg-8 p-0 m-0 d-flex mt-3">
              <input type="number" class="form-control" v-model="data.score"/>
            </div> -->
          </div>
        </div>
        <div class="d-flex align-items-center" v-for="(data1,index1) in data.arr_option" :key="'question_'+index+'_option_'+index1">

          <div class="mdc-form-field">
            <div class="mdc-radio" >
              <input class="mdc-radio__native-control"  type="radio" id="radio-1" checked>
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
              <div class="mdc-radio__ripple"></div>
            </div>
            <label for="radio-1" class="m-0" v-show="!data1.is_edit">{{ data1.option }}</label>
            <div v-show="data1.is_edit">
              <input type="text" class="form-control" placeholder="Option" v-model="data1.option">
            </div>
          </div>
          <div>
            <i class="fas fa-check" @click="edit_option(index,index1)" v-show="data1.is_edit"></i>
            <div v-show="!data1.is_edit">
              <i class="fas fa-edit ml-3" @click="change_edit(index,index1)"></i>
              <i class="fas fa-times ml-3" @click="delete_option(index,index1)"></i>
            </div>
          </div>
          <div class="ml-3">
            <button type="button" v-show="!data1.is_answer" class="btn btn-primary" @click="set_as_answer(index,index1)">Set as answer</button>
            <p class="m-0" v-show="data1.is_answer">This option is answer</p>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-primary" @click="add_option(index)">Tambah Opsi</button>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-danger" @click="delete_question(index)">Hapus Pertanyaan</button>
        </div>
      </div>
    </div>
    <div class="form-group col-12 text-right mt-3">
      <button type="button" class="btn btn-primary" @click="add_question">Tambah Pertanyaan</button>
    </div>
    <div class="form-group col-12 text-right mt-3">
      <button type="button" class="btn btn-danger" onclick="location.href='/news'">Cancel</button>
      <button type="button" class="btn btn-primary" v-on:click="save">Save</button>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'

import 'summernote/dist/summernote.css'
import summernote from 'summernote'

import {MDCFormField} from '@material/form-field';
import {MDCRadio} from '@material/radio';

export default {
  components:{
    'please-wait-modal': please_wait_modal,
  },
  async mounted(){
    var context = this
    $('#description').summernote({
      height: '250',
      width: '100%',
      callbacks: {
        onChange: function(contents, $editable) {
          context.description = contents
        }
      },
      popover: {
        image: [],
        link: [],
        air: []
      },
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
      ]
    })

    $('.summernote').summernote({
      height: '250',
      width: '100%',
      callbacks: {
        onChange: function(contents, $editable) {
          console.log($editable)
          // context.description = contents
        }
      },
      popover: {
        image: [],
        link: [],
        air: []
      },
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
      ]
    })

    if(this.$route.query.id != null){
      await this.get_data()
    }

    const radio = new MDCRadio(document.querySelector('.mdc-radio'));
    const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
    formField.input = radio;
  },
  data(){
    return{
      name: '',
      description: '',
      arr_question: [
        {
          question: '',
          arr_option:[
            {
              option: '',
              is_edit: false,
            }
          ]
        }
      ]
    }
  },
  methods:{
    add_question(){
      var data = {
        question: '',
        arr_option:[]
      }
      this.arr_question.push(data)
    },
    delete_question(index){
      this.arr_question.splice(index,1)
    },
    check_answer(index){
      var arr_option = this.arr_question[index].arr_option
      for(let x in arr_option){
        if(arr_option[x].is_answer)
          return false
      }
      return true
    },
    set_as_answer(index,index1){
      var data = this.arr_question[index]

      for(let x in data.arr_option)
        data.arr_option[x].is_answer = false

      data.arr_option[index1].is_answer = true
      this.$set(this.arr_question,index,data)
    },
    add_option(index){
      var data = this.arr_question[index]
      var data_option = {
        option: '',
        is_answer: this.check_answer(index),
        is_edit: false,
      }
      data.arr_option.push(data_option)
      this.$set(this.arr_question,index,data)
    },
    edit_option(index,index1){
      var data = this.arr_question[index]
      data.arr_option[index1].is_edit = false
      this.$set(this.arr_question,index,data)
    },
    delete_option(index,index1){
      var data = this.arr_question[index]
      data.arr_option.splice(index1,1)
      this.$set(this.arr_question,index,data)
    },
    change_edit(index,index1){
      var data = this.arr_question[index]
      data.arr_option[index1].is_edit = true
      this.$set(this.arr_question,index,data)
      console.log(index)
    },
    async save(){
      try{
        var flag = true
        var message = ''
        for(let x in this.arr_question){
          if(this.arr_question[x].question == ''){
            flag = false
            message = 'Question number '+(parseInt(x)+1)+' is empty'
            break
          }
          else{
            var flag1 = true
            for(let y in this.arr_question[x].arr_option){
              if(this.arr_question[x].arr_option[y].option == ''){
                flag1 = false
                message = 'Option number '+(parseInt(y)+1)+' at question number '+(parseInt(x)+1)+' is empty'
                break
              }
            }
            if(!flag1){
              flag = false
              break
            }
          }
        }

        if(this.name == '')
          this.$toasted.show('Name is empty')
        else if(this.description == '')
          this.$toasted.show('Description is empty')
        else if(this.arr_question.length == 0)
          this.$toasted.show('Total question is empty')
        else if(!flag)
          this.$toasted.show(message)
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          data.name = this.name
          data.description = this.description
          data.arr_question = this.arr_question
          if(this.$route.query.id != null)
            data.id = this.$route.query.id

          var response
          if(this.$route.query.id == null)
            response = await axios.post(base_url+'/online-test',data)
          else
            response = await axios.put(base_url+'/online-test',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/online-test'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e) {
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/online-test/base?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.name = response_data.data.name
          this.description = response_data.data.description

          var arr = []
          for(let x in response_data.data.question){
            var data = response_data.data.question[x]
            data.arr_option = response_data.data.question[x].option

            for(let y in data.arr_option){
              if(data.arr_option[y].id == data.answer_id)
                data.arr_option[y].is_answer = true
              else
                data.arr_option[y].is_answer = false
            }
            console.log(data)

            arr.push(data)
          }
          this.arr_question = arr
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    }
  }
}
</script>

<style lang="scss">
@use "@material/form-field/mdc-form-field";
@use "@material/radio/mdc-radio";
</style>
